import { FormGroup } from "@angular/forms";

export const keyboardInputValidators = (event: KeyboardEvent, pattern: any, limit?: HTMLInputElement, length: number = 1 ) => {
  const input = event.key;

  // Allowed keys (e.g., Backspace, Delete, Arrow keys, etc.)
  const allowedKeys = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'ArrowUp',
    'ArrowDown',
    'Tab',
    'Escape',
    'Enter',
  ];

  // Allow key combinations with Ctrl, Alt, or Meta keys
  if (
    allowedKeys.includes(input) ||
    event.ctrlKey ||
    event.altKey ||
    event.metaKey
  ) {
    return;
  }

  if (!pattern.test(input) || (limit && limit?.value.length > length)) {
    event.preventDefault();
  }
}
